import React, { useState } from "react";
import Marquee from "react-fast-marquee";

import logo from "assets/logo.svg";
import logoXS from "assets/logo-xs.svg";
import chevron from "assets/chevron.svg";
import odin from "assets/hero-android.png";
import steamDeck from "assets/hero-steamos.png";
import ally from "assets/hero-windows.png";
import steam from "assets/steam.png";
import emudeckMachine from "assets/emudeck_machine.png";
import allyOutline from "assets/ally.png";

import androidLogo from "assets/androidLogo.png";
import appleLogo from "assets/appleLogo.png";
import linuxLogo from "assets/linuxLogo.png";
import steamOSlogo from "assets/steamOSlogo.png";
import windowsLogo from "assets/windowsLogo.png";
import ChimeraOSlogo from "assets/ChimeraOSlogo.svg";

//Default BaseCore components
import {
  BtnSimple,
  //   BtnGroup,
  //   BtnSwitch,
  //   Icon,
  LinkSimple,
  Img,
  //   Iframe,
  //   List,
  //   ProgressBar,
  //   FormInputSimple,
  //   FormSelectSimple,
  //   FormRadioSimple,
  //   FormCheckboxSimple,
  //   FormInputRangeSimple,
} from "getbasecore/Atoms";

import Section from "../components/molecules/Section/Section";
import Modal from "../components/molecules/Modal/Modal";
export const Home = () => {
  const [statePage, setStatePage] = useState({
    platform: "steamOS",
    modal: false,
  });
  const { platform, modal } = statePage;
  const changeHighlight = () => {
    let next;
    switch (platform) {
      case "steamOS":
        next = "Windows";
        break;
      case "Windows":
        next = "Android";
        break;
      default:
        next = "steamOS";
        break;
    }

    setStatePage({ platform: next });
  };

  const communityLinuxDefault = (
    <>
      <li>Emulator installer with auto setup</li>
      <li>Integrate your games with your Steam Library</li>
      <li>EmulationStation and Pegasus</li>
      <li>EmuDeck Compressor</li>
      <li>Decky plugin</li>
      <li>Bios Checker</li>
      <li>3rd party tools installer</li>
      <li>Rom import tool</li>
    </>
  );
  const communityLinuxPerks = (
    <>
      <li>
        CloudSync - Sync your saved games between SteamOS, Linux and Windows with Android sync support coming in 2026
      </li>
      <li>Early access to new features</li>
      <li>Direct 1 to 1 support</li>
      <li>Exclusive Discord channels</li>
    </>
  );

  const showSteamOSModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Pick your EmuDeck flavour</span>,
      css: "modal--windows",
      body: (
        <>
          <div>
            <span className="h5">EmuDeck Community</span>
            <ul className="list">{communityLinuxDefault}</ul>
            <BtnSimple css="btn-simple--1" href="EmuDeck.desktop" type="link" aria="Download EmuDeck for Free">
              Download for Free
            </BtnSimple>
          </div>
          <div className="">
            <span className="h5">EmuDeck EA</span>
            <p>Same features as Community plus:</p>
            <strong>Exclusive Perks:</strong>
            <ul className="list">{communityLinuxPerks}</ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  const showLinuxModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Pick your EmuDeck flavour</span>,
      css: "modal--windows",
      body: (
        <>
          <div>
            <span className="h5">EmuDeck Community</span>
            <ul className="list">{communityLinuxDefault}</ul>
            <BtnSimple css="btn-simple--1" href="EmuDeck.sh" type="link" aria="Download EmuDeck for Free">
              Download for Free
            </BtnSimple>
          </div>
          <div className="">
            <span className="h5">EmuDeck EA</span>
            <p>Same features as Community plus:</p>
            <strong>Exclusive Perks:</strong>
            <ul className="list">{communityLinuxPerks}</ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  const showChimeraModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Pick your EmuDeck flavour</span>,
      css: "modal--windows",
      body: (
        <>
          <div>
            <span className="h5">EmuDeck Community</span>
            <ul className="list">{communityLinuxDefault}</ul>
            <BtnSimple
              css="btn-simple--1"
              href="https://github.com/EmuDeck/emudeck-electron/releases/download/v2.2.18/EmuDeck-2.2.18.AppImage"
              type="link"
              aria="Download EmuDeck for Free">
              Download for Free
            </BtnSimple>
          </div>
          <div className="">
            <span className="h5">EmuDeck EA</span>
            <p>Same features as Community plus:</p>
            <strong>Exclusive Perks:</strong>
            <ul className="list">{communityLinuxPerks}</ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  const showWindowsModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Pick your EmuDeck flavour</span>,
      css: "modal--windows",
      body: (
        <>
          <div>
            <span className="h5">EmuDeck Community</span>
            <ul className="list">
              <li>Emulator installer with auto setup</li>
              <li>Integrate your games with your Steam Library</li>
              <li>EmulationStation and Pegasus</li>
              <li>Bios Checker</li>
            </ul>
            <BtnSimple css="btn-simple--1" href="EmuDeck.cmd" type="link" aria="Download EmuDeck for Free">
              Download for Free
            </BtnSimple>
          </div>
          <div className="">
            <span className="h5">EmuDeck EA</span>
            <p>Same features as Community plus:</p>
            <strong>Exclusive Perks:</strong>
            <ul className="list">
              <li>
                CloudSync - Sync your saved games between SteamOS, Linux and Windows with Android sync support coming in
                2026
              </li>
              <li>Early access to new features</li>
              <li>Direct 1 to 1 support</li>
              <li>Exclusive Discord channels</li>
              <li>Android APK - EmuDeck in your Android device!</li>
              <li>Game Mode - Turn your device into a Steam Deck like experience.</li>
            </ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  const showAndroidModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Early Access Only</span>,
      css: "modal--windows",
      body: (
        <>
          <div className="">
            <p>EmuDeck for Android in in Early Access mode and it's only available for our patrons</p>
            <strong>Besides EmuDeck for Android you get the following exclusive perks:</strong>

            <ul className="list">
              <li>
                CloudSync - Sync your saved games between SteamOS, Linux and Windows with Android sync support coming in
                2026
              </li>
              <li>Early access to new features</li>
              <li>Direct 1 to 1 support</li>
              <li>Exclusive Discord channels</li>
            </ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  const showMacOSModal = () => {
    const modalData = {
      active: true,
      header: <span className="h4">Pick your EmuDeck flavour</span>,
      css: "modal--windows",
      body: (
        <>
          <div>
            <span className="h5">EmuDeck Community</span>
            <ul className="list">
              <li>Emulator installer with auto setup</li>
              <li>EmulationStation</li>
              <li>Bios Checker</li>
              <li>Only RetroArch at the moment</li>
            </ul>
            <BtnSimple css="btn-simple--1" href="EmuDeck.app" type="link" aria="Download EmuDeck for Free">
              Download for Free
            </BtnSimple>
          </div>
          <div className="">
            <span className="h5">EmuDeck EA</span>
            <p>Same features as Community plus:</p>
            <strong>Exclusive Perks:</strong>
            <ul className="list">
              <li>
                CloudSync - Sync your saved games between SteamOS, Linux and Windows with Android sync support coming in
                2026
              </li>
              <li>Early access to new features</li>
              <li>Direct 1 to 1 support</li>
              <li>Exclusive Discord channels</li>
              <li>Early access to new emulators</li>
            </ul>
            <BtnSimple
              css="btn-simple--2"
              href="https://www.patreon.com/join/dragoonDorise"
              target="_blank"
              type="link"
              aria="Join our Patreon">
              Join our Patreon
            </BtnSimple>
          </div>
        </>
      ),
      footer: <div></div>,
    };

    setStatePage({ ...statePage, modal: modalData });
  };

  return (
    <div className={`wrapper ${platform}`}>
      <Modal modal={modal} />
      <svg id="big-blob-svg" xmlns="http://www.w3.org/2000/svg">
        <clipPath id="big-blob" clipPathUnits="objectBoundingBox">
          <path d="M0.689,0.167 c0.073,0.039,0.151,0.083,0.215,0.161 c0.063,0.078,0.109,0.189,0.093,0.292 c-0.017,0.103,-0.096,0.196,-0.192,0.265 c-0.096,0.069,-0.208,0.114,-0.321,0.115 c-0.113,0.001,-0.225,-0.043,-0.317,-0.114 C0.076,0.815,0.007,0.717,0.001,0.617 c-0.007,-0.1,0.048,-0.202,0.079,-0.316 C0.111,0.186,0.118,0.06,0.181,0.018 c0.064,-0.043,0.184,-0.001,0.277,0.037 c0.093,0.038,0.159,0.073,0.231,0.112" />
        </clipPath>
      </svg>
      <div className="big-blob"></div>
      <header className="header">
        <div className="container">
          <div className="header__inner">
            <svg
              class="logo header__logo"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 994.95 202.67">
              <defs>
                <linearGradient
                  id="a"
                  x1="-276.85"
                  x2="-275.85"
                  y1="926.08"
                  y2="926.08"
                  gradientTransform="matrix(200.48 0 0 -200.48 55503.6 185757.41)"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#d00888" />
                  <stop offset="1" stop-color="#1274e3" />
                </linearGradient>
                <linearGradient
                  xlinkHref="#a"
                  id="d"
                  x1="-276.86"
                  x2="-275.86"
                  y1="926.09"
                  y2="926.09"
                  gradientTransform="matrix(198.99 0 0 -198.99 55096.2 184402.34)"
                />
                <clipPath id="b">
                  <path
                    fill="transparent"
                    stroke="#000000"
                    stroke-width="4"
                    class="path"
                    d="M76.28 181.33 21 126.05c-4.01-4.01-5.16-9.8-3.47-14.84.69-2.05 1.84-3.98 3.47-5.61l10.11-10.11 65.31-65.32v131.27l-.09 11.69c-.03 3.1-1.25 6.01-3.44 8.21-2.29 2.29-5.3 3.43-8.3 3.43s-6.01-1.15-8.3-3.43M112.14 16.5c.95-.33 1.93-.56 2.92-.68.66-.08 1.32-.12 1.99-.11.33 0 .66.02.99.04a14.379 14.379 0 0 1 9.07 4.18l55.28 55.28c.45.45.84.94 1.21 1.44.33.45.63.92.89 1.4.18.34.34.69.48 1.04.29.71.5 1.44.64 2.18a12.05 12.05 0 0 1 0 4.48c-.14.74-.36 1.47-.64 2.18-.14.35-.3.7-.48 1.04a11.82 11.82 0 0 1-3.86 4.3c-.63.42-1.3.78-1.99 1.07a11.9 11.9 0 0 1-4.44.91l-23.37.19c-.3 0-.59.02-.88.03h-37.79V16.5Zm0-16.13c-5.71.9-11.2 3.44-15.72 7.61-.3.27-.59.55-.88.84L9.88 94.48c-.33.33-.64.66-.95 1a29.925 29.925 0 0 0-7.51 15.72c-1.41 9.18 1.41 18.9 8.47 25.96l55.28 55.28c8.44 8.44 21.05 10.22 31.26 5.36 2.74-1.31 5.31-3.09 7.58-5.36 5.13-5.13 7.98-11.95 8.04-19.2l.09-11.68V111.2h38.3c.17 0 .33-.03.5-.03l23.37-.19c7.25-.06 14.07-2.91 19.2-8.04 2.23-2.23 3.99-4.76 5.3-7.46 4.94-10.23 3.18-22.91-5.3-31.38L138.22 8.82C132.34 2.94 124.61 0 116.89 0c-1.59 0-3.18.12-4.75.37"
                  />
                </clipPath>
                <clipPath id="c">
                  <path
                    fill="transparent"
                    stroke="#000000"
                    stroke-width="4"
                    class="path"
                    d="m63.59 99.73-4.92 4.92-4.92-4.92a7.864 7.864 0 0 0-11.12 0 7.864 7.864 0 0 0 0 11.12l4.92 4.92-4.92 4.92a7.864 7.864 0 0 0 0 11.12 7.864 7.864 0 0 0 11.12 0l4.92-4.92 4.92 4.92a7.864 7.864 0 0 0 11.12 0 7.864 7.864 0 0 0 0-11.12l-4.92-4.92 4.92-4.92a7.864 7.864 0 0 0 0-11.12c-1.54-1.54-3.55-2.3-5.56-2.3s-4.02.77-5.56 2.3"
                  />
                </clipPath>
              </defs>
              <g clip-path="url(#b)">
                <path fill="url(#a)" d="M0 0h203.74v202.67H0z" />
              </g>
              <g clip-path="url(#c)">
                <path fill="url(#d)" d="M39.55 96.66h38.22v38.22H39.55z" />
              </g>
              <path
                fill="#000"
                stroke="#000000"
                stroke-width="1"
                class="path"
                d="M283.66 90.43h44.42c2.16 0 4.03.76 5.61 2.28 1.58 1.58 2.36 3.47 2.36 5.69v.18c0 2.22-.79 4.12-2.36 5.69-1.58 1.52-3.45 2.28-5.61 2.28h-44.42v28.39c0 3.62 1.28 6.72 3.85 9.29 2.57 2.57 5.66 3.86 9.29 3.86h31.28c2.16 0 4.03.79 5.61 2.36 1.58 1.58 2.36 3.48 2.36 5.7v.18c0 2.22-.79 4.09-2.36 5.61-1.58 1.58-3.45 2.36-5.61 2.36H296.8c-8.12 0-15.04-2.86-20.76-8.59-5.72-5.72-8.59-12.64-8.59-20.76V62.04c0-8.12 2.86-15.04 8.59-20.76 5.72-5.72 12.65-8.59 20.76-8.59h31.28c2.16 0 4.03.79 5.61 2.36 1.58 1.52 2.36 3.39 2.36 5.61v.18c0 2.22-.79 4.12-2.36 5.7-1.58 1.58-3.45 2.36-5.61 2.36H296.8c-3.62 0-6.72 1.28-9.29 3.85-2.57 2.57-3.85 5.67-3.85 9.29v28.39ZM366.71 156.31c0 2.22-.79 4.09-2.36 5.61-1.58 1.58-3.45 2.36-5.61 2.36h-.26c-2.16 0-4.03-.79-5.61-2.36-1.58-1.52-2.37-3.39-2.37-5.61V72.2c0-10.92 3.85-20.24 11.57-27.95s17.03-11.56 27.95-11.56c13.02 0 23.51 5.17 31.45 15.51 7.88-10.34 18.34-15.51 31.36-15.51 10.92 0 20.24 3.86 27.95 11.56 7.71 7.71 11.56 17.03 11.56 27.95v84.1c0 2.22-.76 4.09-2.28 5.61-1.58 1.58-3.47 2.36-5.69 2.36h-.17c-2.22 0-4.09-.79-5.61-2.36-1.58-1.52-2.37-3.39-2.37-5.61V72.2c0-6.48-2.28-12-6.83-16.56-4.56-4.55-10.08-6.83-16.56-6.83s-11.91 2.28-16.47 6.83c-4.56 4.56-6.83 10.08-6.83 16.56v84.1c0 2.22-.79 4.09-2.37 5.61-1.52 1.58-3.39 2.36-5.61 2.36h-.17c-2.22 0-4.12-.79-5.7-2.36-1.58-1.52-2.37-3.39-2.37-5.61V72.2c0-6.48-2.28-12-6.83-16.56s-10.04-6.83-16.47-6.83-11.92 2.28-16.47 6.83c-4.55 4.56-6.83 10.08-6.83 16.56v84.1ZM748.51 90.43h44.42c2.16 0 4.03.76 5.61 2.28 1.58 1.58 2.36 3.47 2.36 5.69v.18c0 2.22-.79 4.12-2.36 5.69-1.58 1.52-3.45 2.28-5.61 2.28h-44.42v28.39c0 3.62 1.28 6.72 3.85 9.29 2.57 2.57 5.66 3.86 9.29 3.86h31.28c2.16 0 4.03.79 5.61 2.36s2.36 3.48 2.36 5.7v.18c0 2.22-.79 4.09-2.36 5.61-1.58 1.58-3.45 2.36-5.61 2.36h-31.28c-8.12 0-15.04-2.86-20.76-8.59-5.73-5.72-8.59-12.64-8.59-20.76V62.04c0-8.12 2.86-15.04 8.59-20.76 5.72-5.72 12.64-8.59 20.76-8.59h31.28c2.16 0 4.03.79 5.61 2.36 1.58 1.52 2.36 3.39 2.36 5.61v.18c0 2.22-.79 4.12-2.36 5.7-1.58 1.58-3.45 2.36-5.61 2.36h-31.28c-3.62 0-6.72 1.28-9.29 3.85-2.57 2.57-3.85 5.67-3.85 9.29v28.39ZM894.46 34.71c4.03 1.05 6.05 3.62 6.05 7.71v.26c0 2.57-1.05 4.67-3.15 6.31-2.05 1.58-4.32 2.04-6.83 1.4a49.859 49.859 0 0 0-12.44-1.58c-13.67 0-25.35 4.85-35.04 14.54-9.7 9.7-14.54 21.41-14.54 35.13s4.85 25.44 14.54 35.13c9.69 9.64 21.38 14.46 35.04 14.46 4.21 0 8.35-.5 12.44-1.49 2.51-.64 4.79-.18 6.83 1.4 2.1 1.58 3.15 3.68 3.15 6.31v.17c0 4.15-2.02 6.75-6.05 7.8a67.472 67.472 0 0 1-16.38 2.02c-18.16 0-33.67-6.43-46.52-19.27-12.85-12.85-19.27-28.36-19.27-46.52s6.42-33.67 19.27-46.52c12.85-12.85 28.35-19.27 46.52-19.27 5.55 0 11.01.67 16.38 2.02M923.64 32.69c2.16 0 4.03.76 5.61 2.28 1.58 1.58 2.37 3.47 2.37 5.69v45.38h11.74c8.7 0 16.12-3.07 22.25-9.2 6.19-6.13 9.32-13.55 9.37-22.25V40.66c0-2.22.79-4.12 2.36-5.69 1.52-1.52 3.39-2.28 5.61-2.28h.26c2.16 0 4.03.76 5.61 2.28 1.58 1.58 2.37 3.47 2.37 5.69v13.93c0 16-6.43 28.79-19.27 38.37 7.07 4.26 12.64 9.96 16.73 17.08 4.2 7.36 6.31 15.3 6.31 23.83v22.43c0 2.22-.76 4.09-2.28 5.61-1.58 1.58-3.47 2.37-5.7 2.37h-.17c-2.22 0-4.12-.79-5.69-2.37-1.52-1.52-2.28-3.39-2.28-5.61v-22.43c-.06-8.7-3.18-16.12-9.37-22.25-6.19-6.13-13.64-9.2-22.34-9.2h-15.51v53.88c0 2.22-.79 4.09-2.37 5.61-1.58 1.58-3.45 2.37-5.61 2.37h-.26c-2.16 0-4.03-.79-5.61-2.37-1.58-1.52-2.36-3.39-2.36-5.61V40.66c0-2.22.79-4.12 2.36-5.69 1.58-1.52 3.45-2.28 5.61-2.28h.26ZM594.67 34.97c-1.58-1.52-3.45-2.28-5.61-2.28h-.26c-2.16 0-4.03.76-5.61 2.28-1.58 1.58-2.36 3.47-2.36 5.7v80.94c0 7.3-2.57 13.55-7.71 18.75-5.2 5.14-11.48 7.71-18.84 7.71s-13.55-2.57-18.75-7.71c-5.14-5.2-7.71-11.45-7.71-18.75V40.66c0-2.22-.79-4.12-2.36-5.7-1.58-1.52-3.45-2.28-5.61-2.28h-.26c-2.16 0-4.03.76-5.61 2.28-1.58 1.58-2.36 3.47-2.36 5.7v80.95c0 11.8 4.17 21.84 12.53 30.14 8.35 8.35 18.4 12.53 30.14 12.53 10.12 0 18.96-3.08 26.55-9.22 1.26-1.02 2.49-2.12 3.68-3.31 8.35-8.29 12.53-18.34 12.53-30.14V40.66c0-2.22-.79-4.12-2.36-5.7M698.13 51.97c-12.85-12.85-28.36-19.27-46.52-19.27h-13.23c-2.06 0-4.01.25-5.87.74-3.62.96-6.87 2.84-9.72 5.65-4.32 4.32-6.48 9.55-6.48 15.68v62.04c0 2.22.79 4.12 2.37 5.7 1.58 1.52 3.45 2.28 5.61 2.28h.26c2.16 0 4.03-.76 5.61-2.28 1.58-1.58 2.36-3.48 2.36-5.7V54.77c0-1.63.56-3.04 1.67-4.2 1.17-1.17 2.57-1.75 4.2-1.75h13.23c13.72 0 25.44 4.85 35.13 14.54 9.69 9.7 14.54 21.41 14.54 35.13s-4.85 25.44-14.54 35.13c-9.69 9.64-21.41 14.46-35.13 14.46h-47.19v.03c-1.97.13-3.67.9-5.11 2.34-1.52 1.58-2.28 3.45-2.28 5.61v.26c0 2.16.76 4.03 2.28 5.61 1.44 1.44 3.14 2.21 5.11 2.34v.03h47.19c18.16 0 33.67-6.42 46.52-19.27 12.85-12.85 19.27-28.36 19.27-46.52s-6.43-33.67-19.27-46.52"
              />
            </svg>

            <div class="header__links">
              <a className="header__link" href="#guide">
                Guide
              </a>
              <a className="header__link" href="#downloads">
                Download
              </a>
              <a className="header__link" target="_blank" href="https://store.emudeck.com/">
                Game Store
              </a>
              <a className="header__link" target="_blank" href="https://manual.emudeck.com/" rel="noreferrer">
                Manual
              </a>
            </div>
          </div>
        </div>
      </header>
      <main className="main">
        <section className="hero">
          <div className="container container--grid">
            <div data-col-sm="6">
              <hgroup>
                <h1 className="h1">Emulation</h1>
                <h2 className="h2">
                  made easy
                  <br />
                  on <span className="is-highlight">{platform}</span>
                </h2>
              </hgroup>
              <p className="lead">
                EmuDeck takes care of everything.
                <br /> Emulator installation & configuration, bezels, hotkeys, performance fixes and more.
              </p>
              <p>
                <BtnSimple css="btn-simple--1" href="#downloads" type="link" aria="Download">
                  Download
                </BtnSimple>{" "}
                <BtnSimple
                  css="btn-simple--3"
                  href="https://manual.emudeck.com"
                  type="link"
                  target="_blank"
                  aria="Read Manual">
                  Read the manual
                </BtnSimple>
              </p>
            </div>
            <div data-col-sm="6">
              <div className="hero__item">
                <button type="button" onClick={() => changeHighlight()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                    <path d="M20 12l-2.83 2.83 9.17 9.17-9.17 9.17 2.83 2.83 12-12z" />
                  </svg>
                </button>

                {platform === "steamOS" && <img src={steamDeck} alt="Odin 2" className="img-no-responsive" />}
                {platform === "Windows" && <img src={ally} alt="Odin 2" className="img-no-responsive" />}
                {platform === "Android" && <img src={odin} alt="Odin 2" className="img-no-responsive" />}
              </div>
            </div>
          </div>
        </section>
        <Section>
          <div className="container">
            <h1 className="h3">Integrated with your Steam Library</h1>
            <p className="lead">We also set up your favourite launcher, EmulationStation or Pegasus</p>
            <Img css="img" src={steam} alt="Steam Library" />
          </div>
        </Section>
        <section>
          <div className="container container--grid">
            <h1 className="h3">A lot more than games</h1>

            <ul data-col-sm="5">
              <li>
                <span className="h4">EmuDeck Compressor</span>
                <p className="lead">
                  Compress your games using the EmuDeck Compressor tool, saving up to 70% disk space!
                </p>
              </li>
              <li>
                <span className="h4">EmuDecky</span>
                <p className="lead">Consult emulator hotkeys directly in Game Mode</p>
              </li>
              <li>
                <span className="h4">BIOS Checker</span>
                <p className="lead">Validate your BIOS using the BIOS Checker tool. BIOS not included</p>
              </li>
            </ul>
            <div data-col-sm="2"></div>
            <ul data-col-sm="5">
              <li>
                <span className="h4">Cloud Saves</span>
                <p className="lead">Backup your saves to the cloud. Cross platform sync available for our Patrons!</p>
              </li>
              <li>
                <span className="h4">SteamDeckGyroDSU</span>
                <p className="lead">Enable your Steam Deck gyroscope for 3DS, Wii, and Wii U games</p>
              </li>
              <li>
                <span className="h4">Power Tools</span>
                <p className="lead">Supercharge your Steam Deck to get maximum performance on emulation</p>
              </li>
            </ul>
            <br />
            <br />
            <div data-col-sm="12">
              <span className="h3">Import / Export Tool</span>
              <p className="lead">Migrate your saved games from one Steam Deck to another</p>
              <BtnSimple css="btn-simple--1" href="EmuDeckExportSaves.desktop" type="link" aria="Export Tool">
                Export Tool
              </BtnSimple>{" "}
              <BtnSimple css="btn-simple--1" href="EmuDeckImportSaves.desktop" type="link" aria="Import Tool">
                Import Tool
              </BtnSimple>
            </div>
          </div>
        </section>
        <Section css="showcase">
          <h1 className="h3">All your favourite systems</h1>
          <p className="lead">
            Play all your favourite retro systems on the go <br />
          </p>
          <Marquee speed="120">
            <img src="logos/3do.svg" lazyload />
            <img src="logos/amiga.svg" lazyload />
            <img src="logos/amstradcpc.svg" lazyload />
            <img src="logos/arcade.svg" lazyload />
            <img src="logos/atari2600.svg" lazyload />
            <img src="logos/atarijaguar.svg" lazyload />
            <img src="logos/atarilynx.svg" lazyload />
            <img src="logos/atomiswave.svg" lazyload />
            <img src="logos/c64.svg" lazyload />
            <img src="logos/daphne.svg" lazyload />
            <img src="logos/doom.svg" lazyload />
            <img src="logos/dos.svg" lazyload />
            <img src="logos/dreamcast.svg" lazyload />
            <img src="logos/easyrpg.svg" lazyload />
            <img src="logos/fbneo.svg" lazyload />
            <img src="logos/gameandwatch.svg" lazyload />
            <img src="logos/gamegear.svg" lazyload />
            <img src="logos/gb.svg" lazyload />
            <img src="logos/gba.svg" lazyload />
            <img src="logos/gbc.svg" lazyload />
            <img src="logos/gc.svg" lazyload />
            <img src="logos/genesis.svg" lazyload />
            <img src="logos/intellivision.svg" lazyload />
            <img src="logos/mame.svg" lazyload />
            <img src="logos/mastersystem.svg" lazyload />
            <img src="logos/megadrive.svg" lazyload />
            <img src="logos/model2.svg" lazyload />
            <img src="logos/model3.svg" lazyload />
            <img src="logos/msx.svg" lazyload />
            <img src="logos/n3ds.svg" lazyload />
            <img src="logos/n64.svg" lazyload />
            <img src="logos/naomi.svg" lazyload />
            <img src="logos/nds.svg" lazyload />
            <img src="logos/neogeo.svg" lazyload />
            <img src="logos/nes.svg" lazyload />
            <img src="logos/ngpc.svg" lazyload />
            <img src="logos/pc88.svg" lazyload />
            <img src="logos/pc98.svg" lazyload />
            <img src="logos/pcengine.svg" lazyload />
            <img src="logos/pico8.svg" lazyload />
            <img src="logos/psx.svg" lazyload />
            <img src="logos/ps2.svg" lazyload />
            <img src="logos/ps3.svg" lazyload />
            <img src="logos/psp.svg" lazyload />
            <img src="logos/psvita.svg" lazyload />
            <img src="logos/saturn.svg" lazyload />
            <img src="logos/scummvm.svg" lazyload />
            <img src="logos/sega32x.svg" lazyload />
            <img src="logos/segacd.svg" lazyload />
            <img src="logos/sfc.svg" lazyload />
            <img src="logos/sg-1000.svg" lazyload />
            <img src="logos/sgb.svg" lazyload />
            <img src="logos/snes.svg" lazyload />
            <img src="logos/supergrafx.svg" lazyload />
            <img src="logos/switch.svg" lazyload />
            <img src="logos/tg-cd.svg" lazyload />
            <img src="logos/tic80.svg" lazyload />
            <img src="logos/virtualboy.svg" lazyload />
            <img src="logos/wii.svg" lazyload />
            <img src="logos/wiiu.svg" lazyload />
            <img src="logos/wonderswancolor.svg" lazyload />
            <img src="logos/xbox.svg" lazyload />
            <img src="logos/xbox360.svg" lazyload />
          </Marquee>
          <div className="container" style={{ position: "relative" }}>
            <div class="showcase__video">
              <div class="iframe-container">
                <iframe
                  src="https://www.youtube-nocookie.com/embed/JlhUPLTvksw?autoplay=1&playlist=JlhUPLTvksw&loop=1&controls=0&mute=1&rel=0&modestbranding=1"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
              </div>
            </div>
            <Img css="showcase__img img" src={allyOutline} alt="Steam Library" />
          </div>
        </Section>
        <section id="guide">
          <div className="container container--grid">
            <h1 className="h3">Video Guides</h1>

            <ul data-col-sm="6">
              <li>
                <span className="h4">SteamOS</span>
                <div className="iframe-container">
                  <iframe
                    src="https://www.youtube-nocookie.com/embed/89-LRCob6H8"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
              </li>
            </ul>
            <ul data-col-sm="6">
              <li>
                <span className="h4">Windows</span>
                <div className="iframe-container">
                  <iframe
                    src="https://www.youtube-nocookie.com/embed/05dunYi6hkY"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <Section css="section--dark" end={false}>
          <div className="container" id="downloads">
            <h1 className="h3">Download EmuDeck</h1>
            <p className="lead">
              EmuDeck updates over the internet so you will only need to download this installer just once
            </p>
            <ul class="download-links">
              <li>
                <span class="h4">steamOS</span>
                <button type="button" onClick={() => showSteamOSModal()}>
                  <img className="img-no-responsive" src={steamOSlogo} alt="picture" />
                </button>
              </li>
              <li>
                {" "}
                <span class="h4">Linux</span>
                <button type="button" onClick={() => showLinuxModal()}>
                  <img className="img-no-responsive" src={linuxLogo} alt="picture" />
                </button>
              </li>{" "}
              <li>
                {" "}
                <span class="h4">Windows</span>
                <button type="button" onClick={() => showWindowsModal()}>
                  <img className="img-no-responsive" src={windowsLogo} alt="picture" />
                </button>
              </li>
              <li>
                <span class="h4">Android Early Access</span>
                <button type="button" onClick={() => showAndroidModal()}>
                  <img className="img-no-responsive" src={androidLogo} alt="picture" />
                </button>
              </li>
              {/*
              <li>
                <span class="h4">macOS (alpha)</span>
                <button type="button" onClick={() => showMacOSModal()}>
                  <img className="img-no-responsive" src={appleLogo} alt="picture" />
                </button>
              </li>
              */}
            </ul>

            <p class="lead">Need any help or want to contact the EmuDeck team?</p>
            <p style={{ textAlign: "center" }}>
              <LinkSimple
                css="link-simple--2"
                target="_blank"
                href="https://www.reddit.com/r/EmuDeck/"
                rel="noreferrer">
                Reddit
              </LinkSimple>{" "}
              |{" "}
              <LinkSimple
                css="link-simple--2"
                target="_blank"
                href="https://github.com/dragoonDorise/EmuDeck"
                rel="noreferrer">
                GitHub
              </LinkSimple>{" "}
              |{" "}
              <LinkSimple css="link-simple--2" target="_blank" href="https://discord.gg/b9F7GpXtFP" rel="noreferrer">
                Discord
              </LinkSimple>{" "}
              |{" "}
              <LinkSimple css="link-simple--2" target="_blank" href="https://twitter.com/emudeck" rel="noreferrer">
                Twitter / X
              </LinkSimple>{" "}
              |{" "}
              <LinkSimple
                css="link-simple--2"
                target="_blank"
                href="https://emudeck.github.io/blog/2024/03/06/emudeck-update-03-06-2024/"
                rel="noreferrer">
                Latest Changelog
              </LinkSimple>{" "}
              |{" "}
              <LinkSimple css="link-simple--2" href="https://manual.emudeck.com/">
                Read the Manual
              </LinkSimple>
            </p>
            <div style={{ textAlign: "center" }}>
              <LinkSimple css="link-simple--2" href="press.zip">
                <strong>Download the press pack</strong>
              </LinkSimple>
            </div>
          </div>
        </Section>
        <Section css="section--early" start={false}>
          <div id="early" className="container">
            <h1 className="h3">Introducing Early Access</h1>
            <p className="lead">
              Interested in getting new features early? Support EmuDeck on Patreon for a sneak peek of the latest
              features like local Co-Op, Android or <strong>exclusive</strong> features like CloudSync for saved games
              or GameMode on Windows.
            </p>
            <p>
              <BtnSimple
                css="btn-simple--2"
                href="https://www.patreon.com/join/dragoonDorise"
                type="link"
                aria="Download">
                Become a Patron
              </BtnSimple>
            </p>
            <span class="h4">EmuDeck's policy regarding donations</span>
            <p class="lead">We are an open source project so we support the whole Emulation open source community.</p>
            <p class="lead">
              EmuDeck's is in a special situation because it needs a lot of tools from some other developers so we want
              to make clear what means making a donation to EmuDeck and be transparent about our own internal rules
            </p>
            <ol class="list">
              <li>
                If we add a third party tool or emulator we'll always ask permission to the developer of said tool.
              </li>
              <li>
                We won’t keep EmuDeck on new platforms like Windows exclusive for early access users for a long time, we
                will release a public beta to the public as soon as we have something stable enough and then work from
                there. Early access users will still get new features first if that doesn't contradict rule #1
              </li>
              <li>
                Everything we code inside our team will be kept as an early access feature, those features will be
                released to our early access users weeks or months before the public release. Some examples of this are
                CloudSyncs of saved games, direct multiplayer, bug fixes, optimizations of Emulators, etc.{" "}
              </li>
              <li>
                We will also give regularly donations to all the tools that EmuDeck uses, so donating to us will also
                allow us to contribute to the entire community.{" "}
              </li>
            </ol>
          </div>
        </Section>
        <section>
          <div class="container container--grid">
            <span class="h3">Credits</span>
            <p>EmuDeck would not be possible without all of these great tools and emulators</p>
            <div data-col-sm="6">
              <ul class="list">
                <li>
                  <a class="h4" target="_blank" href="https://cemu.info/" rel="noreferrer">
                    Cemu (Wii U)
                  </a>
                </li>
                <li>
                  <a
                    class="h4"
                    target="_blank"
                    href="https://github.com/SteamDeckHomebrew/decky-loader"
                    rel="noreferrer">
                    Decky Loader
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://dolphin-emu.org/" rel="noreferrer">
                    Dolphin (Gamecube and Wii)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://www.duckstation.org/" rel="noreferrer">
                    Duckstation (PSX)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://es-de.org/" rel="noreferrer">
                    EmulationStation-DE
                  </a>
                </li>

                <li>
                  <a class="h4" target="_blank" href="https://www.mamedev.org/" rel="noreferrer">
                    MAME (Arcade Systems)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://melonds.kuribo64.net/" rel="noreferrer">
                    melonDS (Nintendo DS)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://mgba.io/" rel="noreferrer">
                    mGBA (Gameboy, Gameboy Color, and Gameboy Advance)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://pegasus-frontend.org/" rel="noreferrer">
                    Pegasus
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://pcsx2.net/" rel="noreferrer">
                    PCSX2 (PS2)
                  </a>
                </li>
              </ul>
            </div>
            <div data-col-sm="6">
              <ul class="list">
                <li>
                  <a class="h4" target="_blank" href="https://www.ppsspp.org/" rel="noreferrer">
                    PPSSPP (PSP)
                  </a>
                </li>
                <li>
                  <a
                    class="h4"
                    target="_blank"
                    href="https://forums.dolphin-emu.org/Thread-fork-primehack-fps-controls-and-more-for-metroid-prime"
                    rel="noreferrer">
                    Primehack (Metroid Prime Trilogy)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://www.retroarch.com/" rel="noreferrer">
                    RetroArch (Retro Systems)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://github.com/Rosalie241/RMG" rel="noreferrer">
                    Rosalie's Mupen GUI (Nintendo 64)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://rpcs3.net/" rel="noreferrer">
                    RPCS3 (Playstation 3)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://ryujinx.org/" rel="noreferrer">
                    Ryujinx (Nintendo Switch)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://www.scummvm.org/" rel="noreferrer">
                    ScummVM (Point and Click Adventures)
                  </a>
                </li>
                <li>
                  <a
                    class="h4"
                    target="_blank"
                    href="https://github.com/SteamGridDB/steam-rom-manager"
                    rel="noreferrer">
                    Steam ROM Manager
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://vita3k.org/" rel="noreferrer">
                    Vita3K (PSVita)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://xemu.app/" rel="noreferrer">
                    Xemu (OG Xbox)
                  </a>
                </li>
                <li>
                  <a class="h4" target="_blank" href="https://xenia.jp/" rel="noreferrer">
                    Xenia (Xbox 360)
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <br />
        </section>
        {/*
        <section className="blobs" style={{ position: "relative" }}>
          <svg
            width="100%"
            height="100%"
            id="svg"
            viewBox="0 0 1440 390"
            xmlns="http://www.w3.org/2000/svg"
            fill="red"
            className="section__wave transition duration-300 ease-in-out delay-150">
            <path
              d="M 0,400 L 0,0 C 109.7129186602871,13.559808612440193 219.4258373205742,27.119617224880386 329,80 C 438.5741626794258,132.8803827751196 548.0095693779905,225.08133971291866 620,223 C 691.9904306220095,220.91866028708134 726.5358851674641,124.55502392344499 822,121 C 917.4641148325359,117.44497607655501 1073.8468899521529,206.69856459330143 1187,202 C 1300.1531100478471,197.30143540669857 1370.0765550239234,98.65071770334929 1440,0 L 1440,400 L 0,400 Z"
              stroke="none"
              stroke-width="0"
              fill-opacity="1"
              class="transition-all duration-300 ease-in-out delay-150 path-1"
              transform="rotate(-180 720 200)"></path>
          </svg>
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>{" "}
          <div class="bloby">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 350">
              <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            </svg>
          </div>
        </section>
				*/}
      </main>
    </div>
  );
};
